module.exports = __webpack_public_path__ + "img/title.027a3ca8.png";